export function generateAlphabetArray() {
  const alphabet = [];
  for (let i = 65; i <= 90; i++) {
    const letter = String.fromCharCode(i);
    alphabet.push(letter);
  }

  return alphabet;
}
